import React from 'react';
import PropTypes from 'prop-types';
import { Button, Alert, Divider } from 'antd';
import { FormItem } from 'formik-antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { getIn } from 'formik';

import { getUrlFromEvent, simpleFilterOptions } from 'utils/form';

import { SingleFileUpload } from 'components/form/upload';
import { DB_PREFIX_REFERENCES as DB_PREFIX } from './constants';

import StagePropTypes from './prop-types';

const getFile = (path, values) => {
  if (!values[path]) return null;
  if (!values[path].fileURL) return null;
  return values[path].fileURL;
};

const ReferenceInput = ({
  values,
  setFieldValue,
  isSubmitting,
  uploadTo,
  errors,
  arrayHelpers,
  i,
}) => {
  const prefix = `${DB_PREFIX}.${i}`;
  const errorFileURL = getIn(errors, `${prefix}.fileURL`);

  const file = getFile(i, values[DB_PREFIX])
    ? {
        name: `${prefix}.fileURL`,
        url: getFile(i, values[DB_PREFIX]),
      }
    : undefined;

  return (
    <>
      <FormItem
        name={`${prefix}.fileURL`}
        style={{ marginTop: 'var(--margin-02)' }}
      >
        <SingleFileUpload
          className="ant-upload ant-upload-drag"
          title=""
          subTitle="Click in this area to upload a reference"
          file={file}
          uploadTo={uploadTo}
          multiple={false}
          showUploadList
          disabled={file != null || isSubmitting}
          onClear={() => {
            setFieldValue(`${prefix}.fileURL`, null);
          }}
          onChange={(e) => {
            setFieldValue(`${prefix}.fileURL`, getUrlFromEvent(e));
          }}
        />
      </FormItem>

      <Button
        type="danger"
        className="dynamic-delete-button"
        onClick={() => arrayHelpers.remove(i)}
      >
        <MinusCircleOutlined className="dynamic-delete-button" />
      </Button>
      <Divider />
    </>
  );
};

ReferenceInput.propTypes = {
  arrayHelpers: PropTypes.shape({
    push: PropTypes.func,
    remove: PropTypes.func,
  }).isRequired,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  uploadTo: PropTypes.string.isRequired,
  errors: PropTypes.shape({}).isRequired,
};

export default ReferenceInput;
